module.exports = __webpack_public_path__ + "img/1563345556.08c7a15a.jpg";